module.exports = __webpack_public_path__ + "static/media/content_manager.2faebb86.svg";